const firebaseConfig = {
    apiKey: "AIzaSyDyx5XuEEiMZY9dXosZv5EXf3kgRvVyy9A",
    authDomain: "happy-baby-my.firebaseapp.com",
    projectId: "happy-baby-my",
    storageBucket: "happy-baby-my.appspot.com",
    messagingSenderId: "1071340962700",
    appId: "1:1071340962700:web:79e96f73d3a80ed13f4ca9"
  };

  export default firebaseConfig;